import p from './activation-of-device.vue';

export default p;
